export default __webpack_public_path__ + "static/media/640_dummy2016-tattoo01-de.2ba55ad8.png";